import React, { useState, useEffect } from "react";
import * as sc from "./styles";
import { MinusIcon } from "../../../../../Components/Icons";

const Input = ({
  id,
  clickIcon,
  initValue = "",
  label,
  onBlur,
  placeholder,
  reset,
  error,
  errorMessage
}) => {
  const [value, setValue] = useState(initValue);

  useEffect(() => {
    if (reset) {
      setValue("");
    }
  }, [reset]);

  function handleChange(e) {
    setValue(e.target.value);
  }

  function handleBlur(e) {
    if (onBlur) {
      onBlur(e.target.value);
    }
  }

  return (
    <sc.Input error={error} clickable={true}>
      <sc.LabelContainer htmlFor={id} onClick={clickIcon}>
        {clickIcon && <MinusIcon />}
        <label htmlFor={id}>{label}</label>
      </sc.LabelContainer>
      <input
        type="text"
        id={id}
        name={id}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {error && errorMessage ? <sc.Error>{errorMessage}</sc.Error> : null}
    </sc.Input>
  );
};

export default Input;
